import "../styles/merchants.css";
import { useEffect, useState } from 'react';
import TokenService from '../services/token_services';
import BusinessService from '../services/business_services';

import LOYALBUDS from "../media/images/loyalbuds_dark_pro.png";
import APPLICATION2 from "../media/images/application2.png";
import Tilt from 'react-parallax-tilt';
import { FaAppStore, FaDiscord, FaGooglePlay, FaInstagram, FaTwitter, FaUserAstronaut, FaShoppingBag, FaPaperPlane, FaSignInAlt, FaFacebook } from "react-icons/fa";
//import { isMobile } from 'react-device-detect';

//TRANSLATION
import { useTranslation } from 'react-i18next';
import { isMobile } from "react-device-detect";
import { useSearchParams } from "react-router-dom";

function RewardValidation() {
  const { t, i18n } = useTranslation();
  const [profile, setProfile] = useState(null);
  const [searchParams] = useSearchParams();
  const [reward, setReward] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [vc] = useState(searchParams.get("vc"));
  const [pid] = useState(searchParams.get("pid"));
  const [qid] = useState(searchParams.get("qid"));

  const fetchProfile = async () => {
    try {
      const response = await TokenService.getProfile();
      console.log("Profile data:", response);
      if (response && response.business) {
        setProfile(response.business);
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
      setProfile(null);
    }
  };

  const validateReward = async () => {
    try {
      setLoading(true);
      const response = await BusinessService.validateReward(vc, pid, qid);
      if (response) {
        setReward(response);
      } else {
        setError("Erreur de validation");
      }
      setLoading(false);
    } catch (error) {
      setError("Erreur de validation");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (qid && !loading) validateReward();
  }, [qid]);

  useEffect(() => {
    fetchProfile();
    i18n.changeLanguage('fr');
  }, [i18n]);

  return (
    <div className="m">
      <div className="container">
        <header>
          {profile ?
            <div className="sign_in" onClick={() => window.location.href = "/merchants/buds"}>
              {profile.business_name}
            </div>
            :
            <div className="sign_in" onClick={() => window.location.href = "/merchants/signin"}>
              {t('merchants.signin')}
            </div>
          }
          <img src={LOYALBUDS} className="logo" alt="logo LoyalBuds" />
          <a href="https://discord.com/invite/sHbvCwhPGz" target="_blank" rel="noreferrer" className="right_entry social"><FaDiscord /></a>
          <a href="https://twitter.com/LoyalBuds" target="_blank" rel="noreferrer" className="right_entry social"><FaTwitter /></a>
          <a href="https://www.facebook.com/loyalbudsapp" target="_blank" rel="noreferrer" className="right_entry social"><FaFacebook /></a>
          <a href="https://www.instagram.com/loyalbudsgame/" target="_blank" rel="noreferrer" className="right_entry social"><FaInstagram /></a>
          <span className="right_entry search_entry" onClick={() => window.location.href = "/merchants/signin"}><FaSignInAlt /></span>
          <span className="right_entry mobile_entry active" onClick={() => window.location.href = "/merchants"}><FaShoppingBag /></span>
          <span className="right_entry mobile_entry" onClick={() => window.location.href = "/players"}><FaUserAstronaut /></span>
        </header>
        <div className="content pro" style={{ paddingTop: "50px" }}>

          {reward ? <>
            <div style={{ display: "inline-block", width: isMobile ? "100%" : "65%", verticalAlign: "middle" }}>
              <span className="notice">Validation de récompense</span>
              <h1 className="title" style={{ color: reward.status ? "green" : "red" }}>
                {reward.status ? "Récompense valide !" : "Récompense non valide"}
              </h1>
              <p className="reward">
                <strong>Récompense : </strong> {reward.reward?.description}
              </p>
              <p>
                Informations du joueur
              </p>
              <table className="reward_player">
                <tbody>
                  <tr>
                    <td>
                      <div className="avatar" style={{ backgroundImage: `url('${reward.player?.avatar}')` }}></div>
                    </td>
                    <td>
                      <span className="username">{reward.player?.username}</span>
                      <br />
                      <span className="nb_scans">Nombre de scans: <strong>{reward.player?.nb_scan}</strong></span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div style={{ display: "inline-block", width: isMobile ? "100%" : "35%", verticalAlign: "middle" }}>
              <div className="card_holder">
                <Tilt>
                  <div className={`card common`}>
                    <h2 className="serie">{reward.business?.bud?.bud_info?.bud_name}</h2>
                    <h5 className="rarity">{reward.business?.bud?.bud_info?.bud_level}</h5>
                    <div className="power">
                      <big>{reward.business?.bud?.nb_holders}</big>
                      <span>
                        <small>distribués</small>
                      </span>
                    </div>
                    <div className="bud" style={{ backgroundImage: `url('${reward.business?.bud?.bud_info?.img_url}')` }}></div>
                  </div>
                </Tilt>
              </div>
            </div>
          </>
            : error &&
            <div style={{ display: "block", width: "100%", verticalAlign: "middle", margin: "150px auto" }}>
              <h1 className="title" style={{ color: "red" }}>
                {error}
              </h1>
              <p className="reward">
                Signature numérique incorrecte.
              </p>
            </div>}
          {!profile && <>
            <div style={{ display: "inline-block", width: isMobile ? "100%" : "35%", verticalAlign: "middle" }}>
              <img src={APPLICATION2} className="application" alt="LoyalBuds application" />
            </div>
            <div style={{ display: "inline-block", width: isMobile ? "100%" : "65%", verticalAlign: "middle" }}>
              <span className="notice">Boost, engage & entertain</span>
              <h1 className="title">
                Débloquez le potentiel de votre commerce
              </h1>
              <p>
                Créez votre compte commerçant et découvrez comment LoyalBuds peut booster votre engagement client.
              </p>
              <div className="signup_button" style={{ display: "block", marginLeft: "20px" }} onClick={() => window.location.href = "/merchants/register"}>
                Créez votre compte
                GRATUITEMENT
              </div>
            </div>
          </>}

          <h1 className="title" style={{ marginTop: "150px", textAlign: "center" }}>
            Des questions, contactez-nous
          </h1>
          <h2 style={{ marginTop: "-2px", paddingLeft: "20px", color: "#333", textAlign: "center" }}>Nous pouvons vous aider à redynamiser votre commerce</h2>
          <p style={{ textAlign: "center" }}>
            Prenez contact avec nous pour en savoir plus, devenir partenaire ou créer une carte à votre image !
          </p>
          <div className="button d-block" onClick={() => window.open("mailTo:contact@loyalbuds.io")}>
            <FaPaperPlane /> Nous contacter
          </div>
        </div>
        <footer>
          <img src={LOYALBUDS} className="logo" alt="logo LoyalBuds" />
          <p className="privacy">
            <a href="/privacy">{t('privacy.policy')}</a> | <a href="/cgu">{t('cgu.general_terms')}</a>
          </p>
          <p className="copyright">
            {t('home.website')}
            <br />
            <strong>Copyright @Codinsight. 2025</strong>
          </p>
          <div className="entry">
            <p>
              <strong>{t('home.editor_title')}</strong>
            </p>
            <p>
              {t('home.editor_blurb')}
            </p>
            <p>
              N° TVA : FR18907943088
              <br />
              Email : contact@codinsight.com
              <br />
              {t('home.director_publishing')}
            </p>
          </div>
          <div className="entry">
            <p>
              <strong>{t('home.hosting')}</strong>
            </p>
            <p>
              {t('home.hosting_details')}
            </p>
            <p>
              Amazon Web Services Inc.
              <br />
              410 Terry Avenue North,
              <br />
              Seattle, WA 98109-5210, USA
            </p>
          </div>
          <div className="entry">
            <div className="link" onClick={() => window.open("https://apps.apple.com/us/app/loyalbuds/id6476626608?platform=iphone")}>
              <FaAppStore />
            </div>
            <div className="link" onClick={() => window.open("https://play.loyalbuds.app")}>
              <FaGooglePlay />
            </div>
            <div className="link" onClick={() => window.open("https://discord.com/invite/sHbvCwhPGz")}>
              <FaDiscord />
            </div>
            <div className="link" onClick={() => window.open("https://twitter.com/LoyalBuds")}>
              <FaTwitter />
            </div>
            <div className="link" onClick={() => window.open("https://www.instagram.com/loyalbudsgame/")}>
              <FaInstagram />
            </div>
            <div className="link" onClick={() => window.open("https://www.facebook.com/loyalbudsapp")}>
              <FaFacebook />
            </div>
          </div>
        </footer>
      </div>
    </div >
  );
}

export default RewardValidation;